<template>
  <div class="iconePass" :class="iconePass">
    <img src="/assets/images/pass.png" alt="Icone Pass" />
    <label v-html="textePass"></label>
  </div>
</template>

<script>
import { idyu_hasPass, idyu_hasSerenity, idyu_isAdmin } from "@/assets/js/idyu/util.js";

export default {
  name: "PassIcon",
  props: ["profile"],

  data() {
    return {
      src: null
    };
  },

  computed: {
    iconePass() {
      if (idyu_isAdmin(this.profile.permission)) {
        return "passAdmin";
      }
      if (idyu_hasSerenity(this.profile.permission)) {
        return "passSere";
      }

      if (idyu_hasPass(this.profile.permission)) {
        return "passIdy";
      }

      return "noPass";
    },

    textePass() {
      if (idyu_isAdmin(this.profile.permission)) {
        return "Pass <b><span class='red'>Admin</span></b>";
      }

      if (idyu_hasSerenity(this.profile.permission)) {
        return "Pass <b><span class='green'>Sérénité</span></b>";
      }

      if (idyu_hasPass(this.profile.permission)) {
        return "Pass " + this.$store.state.siteConst.coloredName;
      }

      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.iconePass {
  img {
    width: 30px;
    height: 30px;
  }
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  grid-gap: 10px;
}

.noPass {
  display: none;
}

.passAdmin {
  display: grid;
}

.passIdy {
  display: grid;
}

.passSere {
  display: grid;
}
</style>
